// Submenu — Trigger controller
//
// Button that opens/closes a submenu. Dispatches submenu:open on click
// and syncs its own [is-open] attribute for icon/style changes.
//
// Usage:
//   <button data-controller="submenu--trigger" data-submenu-id="my-menu"
//     data-action="submenu--trigger#open submenu:close@window->submenu--trigger#close">

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.submenuId = this.element.dataset.submenuId
  }

  open() {
    if (this.element.hasAttribute('is-open')) return

    this.dispatch('open', {
      prefix: 'submenu',
      target: window,
      detail: { id: this.submenuId },
    })

    this.element.setAttribute('is-open', 'true')
  }

  close(event) {
    if (event.detail.id !== this.submenuId || !this.element.hasAttribute('is-open')) return

    this.element.removeAttribute('is-open')
  }
}
